import React, { useState, useEffect } from 'react';
import { PlusCircle } from 'lucide-react';

const ActivityModal = ({ 
  show, 
  activity, 
  activityTypes, 
  wineID,
  wineContainers,
  onClose, 
  onSave,
  onBarrelSelection 
}) => {
  const [newActivity, setNewActivity] = useState({
    type: '',
    description: '',
    startGallons: '',
    endGallons: '',
    difference: 0,
    selectedBarrels: []
  });

  useEffect(() => {
    if (activity) {
      setNewActivity(activity);
    } else {
      setNewActivity({
        type: '',
        description: '',
        startGallons: '',
        endGallons: '',
        difference: 0,
        selectedBarrels: []
      });
    }
  }, [activity, show]);

  const handleAddActivity = () => {
    let difference = null;
    if (newActivity.startGallons && newActivity.endGallons) {
      difference = parseFloat(newActivity.endGallons) - parseFloat(newActivity.startGallons);
    }
    
    onSave({
      ...newActivity,
      difference,
      id: newActivity.id || Date.now(),
      selectedBarrels: newActivity.selectedBarrels || []
    });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Activity</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Activity Type</label>
                <select
                  className="form-control"
                  value={newActivity.type || ''}
                  onChange={(e) => setNewActivity({ ...newActivity, type: e.target.value })}
                  required
                >
                  <option value="">Select Type</option>
                  {activityTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  value={newActivity.description || ''}
                  onChange={(e) => setNewActivity({ ...newActivity, description: e.target.value })}
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Start Gallons</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={newActivity.startGallons || ''}
                    onChange={(e) => setNewActivity({ ...newActivity, startGallons: e.target.value })}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">End Gallons</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={newActivity.endGallons || ''}
                    onChange={(e) => setNewActivity({ ...newActivity, endGallons: e.target.value })}
                  />
                </div>
              </div>

              {newActivity.startGallons && newActivity.endGallons && (
                <div className="mb-3">
                  <label className="form-label">Difference</label>
                  <input
                    type="number"
                    className="form-control"
                    value={(parseFloat(newActivity.endGallons) - parseFloat(newActivity.startGallons)).toFixed(2)}
                    readOnly
                  />
                </div>
              )}

              {wineID && wineContainers[wineID]?.length > 0 && (
                <div className="mb-3">
                  <label className="form-label">Barrels</label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary d-block"
                    onClick={() => onBarrelSelection(newActivity)}
                  >
                    {newActivity.selectedBarrels?.length 
                      ? `${newActivity.selectedBarrels.length} barrels selected` 
                      : 'Select Barrels'
                    }
                  </button>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={handleAddActivity}
              >
                Add Activity
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityModal;